import { GridCol, GridContainer, useIsWindowBiggerThan } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { Form } from '@websrc/App/Components/Form/Form'
import Heading from '@websrc/App/Components/Heading/Heading'
import { MSForm } from '@websrc/App/Components/MSForm/MSForm'
import { mapHeroMSForm } from '@websrc/DataMappers/mapSpot'
import { CSSpot_Settings } from '@websrc/Typings/ContentStack'
import React from 'react'

import SpotContentDecoration from '../SpotContentDecoration/SpotContentDecoration'
import SpotDecoration from '../SpotDecoration/SpotDecoration'
import { layout } from './SpotHeroMSForm.css'

type Props = {
  spot: ReturnType<typeof mapHeroMSForm> & { settings: CSSpot_Settings }
}

export function SpotHeroMSForm({ spot }: Props) {
  const isMobile = !useIsWindowBiggerThan(768)
  return (
    <SpotDecoration spotSettings={spot.settings}>
      <GridContainer>
        <GridCol>
          <SpotContentDecoration spotSettings={spot.settings}>
            <div className={layout._}>
              <div className={layout.left}>
                <Heading
                  description={spot.markdown}
                  headline={spot.headline}
                  label={spot.label}
                  level={spot.headline_level}
                  size={'xl'}
                />

                <Asset
                  className={layout.asset}
                  sizes={'(min-width: 1280px) 600px, 600px'}
                  srcSetWidths={[600, 1200]}
                  thumbnail={spot.asset.thumbnail}
                  video={spot.asset.video}
                />
              </div>
              <div className={layout.right}>
                {spot.form && (
                  <Form
                    action_on_submit={spot.form.action_on_submit}
                    description={spot.form.description}
                    headline={spot.form.headline}
                    realTimeFormScript={spot.form.realTimeFormScript}
                    script={spot.form.script}
                    submit_page_message={spot.form.submit_page_message}
                    submit_redirect_url={spot.form.submit_redirect_url}
                    tracking_enabled={spot.form.tracking_enabled}
                    trackingId={spot.form.trackingId}
                  />
                )}
                {!isMobile && !spot.form && <MSForm formScript={spot.form_script} />}
                {isMobile && !spot.form && (
                  <MSForm
                    formScript={
                      spot.mobile_form_script ? spot.mobile_form_script : spot.form_script
                    }
                  />
                )}
              </div>
            </div>
          </SpotContentDecoration>
        </GridCol>
      </GridContainer>
    </SpotDecoration>
  )
}
